import { type HTMLAttributes } from 'react';

import { cn } from '@/lib/utils';

export type ProgressGoalLabelProps = HTMLAttributes<HTMLSpanElement> & {
  orientation?: 'above' | 'below';
};

const ProgressGoalLabel = ({
  className,
  orientation = 'above',
  ...props
}: ProgressGoalLabelProps) => {
  return (
    <span
      className={cn(
        'absolute right-2 text-xxs whitespace-nowrap',
        orientation === 'above' && '-top-5',
        orientation === 'below' && '-bottom-5',
        className,
      )}
      data-slot="progress-goal-label"
      {...props}
    />
  );
};

export default ProgressGoalLabel;
